define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/CustomerNoteCategoryModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, CustomerNoteCategoryModel, UserContext) {
    "use strict";
    var CustomerNoteCategory = /** @class */ (function () {
        function CustomerNoteCategory() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,NoteCategory.Edit,NoteCategory.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,NoteCategory.Delete"));
            this.editModel = ko.observable(new CustomerNoteCategoryModel());
            this.clearFilterInProgress = false;
            this.categoryList = ko.observableArray([]);
            this.filterByAny = ko.observable("");
        }
        CustomerNoteCategory.prototype.init = function () {
            var self = this;
            $("#page-title").text("Note Categories");
            tools.ajaxGet({
                url: "/CustomerNoteCategory/GetCustomerNoteCategoryLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    $(".js-new-user").on("click", function (event) {
                        //self.createUser();
                        event.preventDefault();
                    });
                    self.initCategories(self.lookupLists.GridStructures.CustomerNoteCategoryStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    //self.initMenu();
                    //self.initLogs();
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerNoteCategory.prototype.initCategories = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<div style="text-align:center"><a class="btn btn-info btn-edit btn-sm" title="Edit" href="#"><i class="fa fa-edit " ></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<a class="btn btn-danger btn-remove btn-sm" title="Delete" href="#"><i class="fa fa-trash-o"></i></a></div>';
                    }
                    return html;
                }
            });
            var gridId = "categoryTable";
            self.categoryTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    toolbar: kendo.template($("#category-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerNoteCategory/GetCustomerNoteCategories",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.categoryTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.categoryTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editCustomerNoteCategory(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteCustomerNoteCategoryConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CustomerNoteCategory.prototype.editCustomerNoteCategory = function (id) {
            var self = this;
            var title = "Add New Category";
            if (!isNaN(id)) {
                title = "Edit Category";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Category Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerNoteCategory(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerNoteCategory/GetCustomerNoteCategoryById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerNoteCategoryModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerNoteCategoryModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'category-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerNoteCategory.prototype.saveCustomerNoteCategory = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerNoteCategory/SaveCustomerNoteCategory",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.categoryTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerNoteCategory.prototype.deleteCustomerNoteCategoryConfirm = function (id, name) {
            var _this = this;
            if (id == 1) {
                tools.error("The default category can't deleted!");
                return;
            }
            tools.confirmModal({
                title: "Delete Customer Note Category",
                text: 'Are you sure you want to delete category "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.deleteCustomerNoteCategory(id);
            });
        };
        CustomerNoteCategory.prototype.deleteCustomerNoteCategory = function (id) {
            var _this = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerNoteCategory/DeleteCustomerNoteCategoryConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Category deleted successfully");
                    _this.categoryTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerNoteCategory.prototype.getCustomerNoteCategoryList = function (cb) {
            var self = this;
            tools.ajaxGet({
                url: "/CustomerNoteCategory/GetCustomerNoteCategoryList",
                data: {},
                success: function (result) {
                    if (result.Success) {
                        self.categoryList(result.Data);
                        if (cb) {
                            cb();
                        }
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
        };
        return CustomerNoteCategory;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CustomerNoteCategory/Index")) {
            log.log("Initialize Customer Note Category");
            $(function () {
                (new CustomerNoteCategory()).init();
            });
        }
    }, 0);
    return CustomerNoteCategory;
});
//# sourceMappingURL=customerNoteCategories.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/customerNoteCategories.js
// module id = 76
// module chunks = 2